<template>
  <div>
    <Breadcrumb :title="'Fair Market Value Statement Footnotes'"></Breadcrumb>
    <BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
    <BaseToolBar :config="FMVStatementfootnoteToolBarConfig" @buttonClicked="toolbarOnClick"></BaseToolBar>
    <BaseGrid
      :config="GridConfig"
      :data="FMVStatementfootnoteGridData"
      :mode="'editform'"
      @EditItem="EditFMVStatementfootnote"
      @DeleteItem="DeleteFMVStatementfootnote"
    ></BaseGrid>
    <FmvStatementFootnoteForm
      :ref="'FmvStatementFootnoteForm'"
      :FmvStatementFootnoteInfo="FMVStatementfootnoteDataJSON"
      :FmvStatementFootnoteModalLabel="modalConfig"
      @SaveComplete="refreshGrid"
    ></FmvStatementFootnoteForm>
  </div>
</template>
<script>
import $ from "jquery";
import { GridConfig, ToolBarConfig } from "./FMVStatementfootnoteConfig.js";
import FmvStatementFootnoteForm from "@/components/forms/FmvStatementFootnoteForm.vue";

import Breadcrumb from "@/components/layout/Breadcrumb.vue";

import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";

import BaseSearchBar from "@/components/base/BaseSearchBar.vue";

import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";

import { mapGetters, mapActions, mapState } from "vuex";
import BaseModelFootnote from "@/models/BaseModelFootnote.js";
import BaseModelFMVStatementFootnote from "@/models/BaseModelFMVStatementFootnote.js";

export default {
  name: "InformationTracker",
  mixins: [apiUtil, funcUtil, toolbarUtility],

  components: {
    Breadcrumb,
    BaseGrid,
    BaseSearchBar,
    BaseToolBar,
    FmvStatementFootnoteForm
  },

  computed: {
    ...mapGetters("getModule", ["withFilter", "getAllItemFilter"]),
    ...mapState("postModule", ["response"])
  },

  data: function() {
    return {
      GridConfig: GridConfig,
      FMVStatementfootnoteGridId: GridConfig.grid.gridId,

      search: {
        SearchData: ""
      },
      FMVStatementfootnoteToolBarConfig: ToolBarConfig,
      FMVStatementfootnoteMasterData: {},

      modalConfig: {
        modalName: "",
        modalAddorEdit: ""
      },

      // customDocumentType:[{Option:"83(b)"},{Option:"Scans"},{Option:"Signature Page"}],
      FMVStatementfootnoteGridData: [],
      FMVStatementfootnoteJSON: {},

      FMVStatementfootnoteDataJSON: {
        Id: "",
        TaxPeriod: "",
        Page: "",
        TagNumber: "",
        TagLocation: "",
        Column: "",
        // InvestmentId: "",
        Investments: "",
        InvestmentGroup: "",
        InvestmentTitle: "",
        FootnoteId: "",
        FootnoteFootnoteID: "",
        Footnote: ""
      },
      FMVStatementfootnoteAPIData: [],
      FootnoteAPIData: []
    };
  },
  mounted() {
    const self = this;
    console.log(self.grid);
    //changes for Toolbar

    //bind databound event to grid
    var grid = $("#FMVStatementFootnoteGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdateDistributionMasterData);

    self.fetchDataandSettings();
  },

  methods: {
    ...mapActions("postModule", ["DeleteItem"]),
    ...mapActions("getModule",["GetItems"]),

    async fetchDataandSettings() {
      await this.getFMVStatementfootnoteData();
      this._loadGridSettings(this.FMVStatementfootnoteGridId);
    },

    UpdateDistributionMasterData: function(fromFilter, filterMasterData) {
      if (fromFilter == true) {
        this.FMVStatementfootnoteMasterData = filterMasterData;
      } else {
        this.FMVStatementfootnoteMasterData = JSON.parse(
          JSON.stringify(
            $("#FMVStatementFootnoteGrid")
              .data()
              .kendoGrid.dataSource.data()
          )
        );
      }
    },

    toolbarOnClick: function(e) {
      const self = this;
      e.preventDefault();
      switch (e.id) {
        case "btnAddFMVStatementfootnote":
          self.AddFMVStatementfootnote();
          window.$("#BaseModal").modal("toggle");
          break;
        case "btnAddFootnote":
          this.$router.push("/valuation/footnote");
          break;
        case "btnRefresh":
          self.refreshGrid();
          break;
        case "btnRollForwardFootnotes":
          self.ConfirmRollForwardFootnotes();
          break;
      }
      this._baseToolBarEvents("FMVStatementFootnoteGrid", ...arguments);
    },

    refreshGrid: function() {
      // console.log("refresh grid Distribution");
      this.fetchDataandSettings();
    },

    filterGrid: function() {
      let self = this;
      var currentMasterdata = this.FMVStatementfootnoteMasterData;
      let filteredData = this._filterGrid(
        this.FMVStatementfootnoteMasterData,
        this.search.SearchData
      );
      $("#FMVStatementFootnoteGrid")
        .data("kendoGrid")
        .dataSource.data(filteredData);
      this.UpdateDistributionMasterData(true, currentMasterdata);
    },

    ConfirmRollForwardFootnotes: async function() {
      var taxPeriods = await this.getPreviousCurrentTaxPeriods();
      var confirmHTML = `
        <h5>Roll Forward from Previous to Current Tax Year?</h5>
        <p><label>Previous Tax Year:</label> ${taxPeriods.previous.year} Q${taxPeriods.previous.quarter}</p>
        <p><label>Current Tax Year:</label> ${taxPeriods.current.year} Q${taxPeriods.current.quarter}</p>
      `;

      this._SweetAlertHTMLPopup('question', 'Roll Forward Footnotes', 'OK', 'Cancel', confirmHTML)
        .then(async (popupResult) =>{
          console.log(popupResult);
          if(!!popupResult && !!popupResult.value)
          {
            var rollForwardResult = await this.rollForwardFMVStatementFootnotes();
            if(rollForwardResult.status == 200)
            {
              //let _self = this;
              //_self.GetItems(BaseModelFMVStatementFootnote);
              await this.GetItems(BaseModelFMVStatementFootnote);
              this._AlertPopup("Footnotes Rolled Forward!", "success");
              this.refreshGrid();
            }
            else
              this._AlertPopup(`HTTP Error: ${rollForwardResult.status}`, "error");
          }
        });
    },

    AddFMVStatementfootnote: function() {
      const self = this;
      self.modalConfig.modalName = "Add FMV Statement Footnote";
      self.modalConfig.modalAddorEdit = "add";

      self.FMVStatementfootnoteDataJSON.Id = "";
      self.FMVStatementfootnoteDataJSON.TaxPeriod = "";
      self.FMVStatementfootnoteDataJSON.Page = "";
      self.FMVStatementfootnoteDataJSON.TagNumber = "";
      self.FMVStatementfootnoteDataJSON.TagLocation = "";
      self.FMVStatementfootnoteDataJSON.Column = "";
      // self.FMVStatementfootnoteDataJSON.InvestmentId = "";
      self.FMVStatementfootnoteDataJSON.Investments = "";
      self.FMVStatementfootnoteDataJSON.InvestmentGroup = "";
      self.FMVStatementfootnoteDataJSON.InvestmentTitle = "";
      self.FMVStatementfootnoteDataJSON.FootnoteId = "";
      self.FMVStatementfootnoteDataJSON.FootnoteFootnoteID = "";
      self.FMVStatementfootnoteDataJSON.Footnote = "";
      self.$refs.FmvStatementFootnoteForm.pageErrors = [];

      self.FMVStatementfootnoteJSON = self.FMVStatementfootnoteDataJSON;
      self.$refs.FmvStatementFootnoteForm.assginSelectedTagOptions("");
    },

    EditFMVStatementfootnote: function(e) {
      let self = this;
      e.preventDefault();
      this.modalConfig.modalName = "Edit FMV Statement Footnote";
      this.modalConfig.modalAddorEdit = "edit";
      var gview = window.$("#FMVStatementFootnoteGrid").data("kendoGrid");
      var dataItem = JSON.parse(
        JSON.stringify(gview.dataItem(window.$(e.currentTarget).closest("tr")))
      );
      dataItem.FootnoteId = dataItem.FootnoteFootnoteID;
      if (dataItem.TagLocation === "Column") {
        self.$refs.FmvStatementFootnoteForm.assginSelectedTagOptions(
          dataItem.TagLocation,
          dataItem.Column
        );
      } else if (dataItem.TagLocation === "Investment Group") {
        self.$refs.FmvStatementFootnoteForm.assginSelectedTagOptions(
          dataItem.TagLocation,
          dataItem.InvestmentGroup
        );
      } else if (dataItem.TagLocation === "Investment") {
        self.$refs.FmvStatementFootnoteForm.assginSelectedTagOptions(
          dataItem.TagLocation,
          dataItem.Investments
        );
      }
      self.FMVStatementfootnoteDataJSON = { ...dataItem };

      self.FMVStatementfootnoteJSON = self.FMVStatementfootnoteDataJSON;

      // self.$refs.refFMVStatementfootnoteForm.getInputControls();

      window.$("#BaseModal").modal("toggle");
    },
    DeleteFMVStatementfootnote: function(e) {
            let self=this;
            e.preventDefault();
            let gview = window.$("#FMVStatementFootnoteGrid").data("kendoGrid");
            var dataItem = JSON.parse(
                     JSON.stringify(gview.dataItem(window.$(e.currentTarget).closest("tr")))
                   );
            const message = "Are you sure you want to delete this record?";
            this._ConfirmationPopup(message, "DELETE").then(result => {
                if (result.value) {
                //let loader = this.$loading.show();
                 this._APICrudPopup("APICrudpopup");
                let deleteData = { Id: dataItem.Id };
                let ItemsToBeDeleted = { list:GridConfig, payload:deleteData }
                this.DeleteItem(ItemsToBeDeleted).then(response => {
                   self.refreshGrid();
                    this._AlertPopup("Deleted successfully!","success");
                }).catch(error=>{
                    this._AlertPopup("Some Error Occurred!","info");
                }).finally(()=>{
                    //loader.hide();
                })
                }
            });
    },
    async getFMVStatementfootnoteData() {
      const self = this;
      let response = await self.getAllItemFilter({
        FMVStatementFootnote: { config: BaseModelFMVStatementFootnote },
        Footnote: { config: BaseModelFootnote }
      });
      if (response) {
        self.FMVStatementfootnoteAPIData = response.FMVStatementFootnote;
        self.FootnoteAPIData = response.Footnote;
      }
      //self.prepareGridData()

      let FMVStatementfootnote = this.FMVStatementfootnoteAPIData;
      let Footnote = this.FootnoteAPIData;

      for (let i = 0; i < FMVStatementfootnote.length; i++) {
        if (FMVStatementfootnote[i].FootnoteFootnoteID) {
          var result = Footnote.filter(function(obj) {
            if (obj.FootnoteID) {
              return (
                obj.FootnoteID.toString()
                  .trim()
                  .toLowerCase() ==
                FMVStatementfootnote[i].FootnoteFootnoteID.toString()
                  .trim()
                  .toLowerCase()
              );
            }
          })[0];
          if (result) {
            FMVStatementfootnote[i].Footnote = result.Footnote;
            //FMVStatementfootnote[i].FootnoteId=result.Id;
          }
        }
      }
      self.FMVStatementfootnoteGridData = FMVStatementfootnote;
    },

    prepareGridData: function() {
      const self = this;
      let FMVStatementfootnote = this.FMVStatementfootnoteAPIData;
      let Footnote = this.FootnoteAPIData;

      for (let i = 0; i < FMVStatementfootnote.length; i++) {
        if (FMVStatementfootnote[i].FootnoteFootnoteID) {
          var result = Footnote.filter(function(obj) {
            if (obj.FootnoteID) {
              return (
                obj.FootnoteID.toString()
                  .trim()
                  .toLowerCase() ==
                FMVStatementfootnote[i].FootnoteFootnoteID.toString()
                  .trim()
                  .toLowerCase()
              );
            }
          })[0];
          if (result) {
            FMVStatementfootnote[i].Footnote = result.Footnote;
            //FMVStatementfootnote[i].FootnoteId=result.Id;
          }
        }
      }
      self.FMVStatementfootnoteGridData = FMVStatementfootnote;
    }
  }
};
</script>
